var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['la-ball-clip-rotate', _vm.wrapperClass]},[_c('div',{class:['w-4 h-4', _vm.loaderClass]})])
}
var staticRenderFns = []

export { render, staticRenderFns }